// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%27186%27 height=%27772%27 viewBox=%270 0 186 772%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M54.2607 226.068C-18.0868 350.987 -18.0868 553.393 54.2607 678.311C90.4422 740.784 137.848 772.014 185.251 772H185.948V0L185.251 0C185.251 0 85.9281 171.496 54.2607 226.068Z%27 fill=%27%23F8BB18%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
}

body {
    margin: 0;
    background-color: #FFF;
    font-family: "Roboto", sans-serif;
}

img {
    max-width: 100%;
    height: auto;
}

button {
    cursor: pointer;
}

.btn {
    background-color: #F8BB18;
    border: none;
    border-radius: 100px;
    font-size: 14px;
    font-weight: 600;
    padding: 12px 24px;
    color: #000;
    text-decoration: none;
}

.btn:hover {
    color: #FFF;
}

.btn--flat {
    background-color: transparent;
    padding: 12px;
}

.btn--flat:hover {
    background-color: rgba(248, 188, 24, 0.2);
    color: #000;
}

.btn--expand {
    min-width: 12rem;
    margin-bottom: 2rem;
}

@media (max-width: 769px) {
    .btn--expand {
        margin-bottom: 1rem;
    }
}

.btn--white {
    background-color: #FFF;
}

.btn--white:hover {
    background-color: rgba(255, 255, 255, 0.9);
    color: #000;
}

/* MAIN */
.inner {
    max-width: 80rem;
    margin: 0 auto;
}

.section a {
    color: #666;
}

.section a:hover {
    color: #000;
}

.section--content {
    padding: 2rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.section--content > * {
    text-align: center;
}

.section--content h1, .section--content h2 {
    font-size: 2.5rem;
}

.section--content h1 span, .section--content h2 span {
    color: #3181F7;
}

.section--content > p {
    font-size: 1.125rem;
    margin-bottom: 2rem;
}

.section--content > p.subtitle {
    margin-top: -1.5rem;
    font-size: 1.25rem;
}

@media (max-width: 769px) {
    .section--content h1, .section--content h2 {
        font-size: 1.5rem;
    }

    .section--content > p {
        font-size: 0.8125rem;
        margin-bottom: 1.5rem;
    }

    .section--content > p.subtitle {
        margin-top: -1rem;
        font-size: 1rem;
    }
}

.section--form {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top right;
}

@media (max-width: 769px) {
    .section--form {
        background-image: none;
    }
}

.section--blue {
    background-color: #3181F7;
    color: #FFF;
}

.section--blue a {
    color: #FFF;
}

.section--blue a:hover {
    color: #000;
}

.section--blue > h1 span, .section--blue > h2 span {
    color: #000;
}

.section--lightblue {
    background-color: #DBECFE;
}

.rowForm {
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
}

.rowButton {
    display: flex;
    justify-content: center;
    margin: 0.5rem 0;
}

.label {
    color: #3181F7;
    font-weight: 500;
    font-size: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    padding: 0 0.75rem;
    margin-bottom: -1.5rem;
    z-index: 5;
}

.input {
    outline: none;
    font-size: 0.85rem;
    border: none;
    background-color: #FFF;
    padding: 2rem 0.75rem 0.5rem;
}

.input:focus {
    outline: 2px solid #333;
}

.input.error {
    outline: 2px solid #C00;
}

.label:has(+ .error) {
    color: #C00;
}


.contentCard {
    text-align: left;
}

.buttonExp {
    margin: 3rem 0;
}

.buttonExp .btn--expand {
    margin: 0;
}

@media (max-width: 769px) {
    .buttonExp {
        margin: 2rem 0;
    }
}

.separador {
    border-top: 1px solid #999;
    width: 100%;
    margin: 2rem 0;
    max-width: 75rem;
}

@media (max-width: 769px) {
    .separador {
        margin: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./js/pages/Homepage/Homepage.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;IAC1C,WAAW;AACf;;AAEA,SAAS;AACT;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI,yDAA2W;IAC3W,wBAAwB;IACxB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,SAAS;IACb;AACJ","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\nhtml {\n    scroll-behavior: smooth;\n}\n\nbody {\n    margin: 0;\n    background-color: #FFF;\n    font-family: \"Roboto\", sans-serif;\n}\n\nimg {\n    max-width: 100%;\n    height: auto;\n}\n\nbutton {\n    cursor: pointer;\n}\n\n.btn {\n    background-color: #F8BB18;\n    border: none;\n    border-radius: 100px;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 12px 24px;\n    color: #000;\n    text-decoration: none;\n}\n\n.btn:hover {\n    color: #FFF;\n}\n\n.btn--flat {\n    background-color: transparent;\n    padding: 12px;\n}\n\n.btn--flat:hover {\n    background-color: rgba(248, 188, 24, 0.2);\n    color: #000;\n}\n\n.btn--expand {\n    min-width: 12rem;\n    margin-bottom: 2rem;\n}\n\n@media (max-width: 769px) {\n    .btn--expand {\n        margin-bottom: 1rem;\n    }\n}\n\n.btn--white {\n    background-color: #FFF;\n}\n\n.btn--white:hover {\n    background-color: rgba(255, 255, 255, 0.9);\n    color: #000;\n}\n\n/* MAIN */\n.inner {\n    max-width: 80rem;\n    margin: 0 auto;\n}\n\n.section a {\n    color: #666;\n}\n\n.section a:hover {\n    color: #000;\n}\n\n.section--content {\n    padding: 2rem 1.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.section--content > * {\n    text-align: center;\n}\n\n.section--content h1, .section--content h2 {\n    font-size: 2.5rem;\n}\n\n.section--content h1 span, .section--content h2 span {\n    color: #3181F7;\n}\n\n.section--content > p {\n    font-size: 1.125rem;\n    margin-bottom: 2rem;\n}\n\n.section--content > p.subtitle {\n    margin-top: -1.5rem;\n    font-size: 1.25rem;\n}\n\n@media (max-width: 769px) {\n    .section--content h1, .section--content h2 {\n        font-size: 1.5rem;\n    }\n\n    .section--content > p {\n        font-size: 0.8125rem;\n        margin-bottom: 1.5rem;\n    }\n\n    .section--content > p.subtitle {\n        margin-top: -1rem;\n        font-size: 1rem;\n    }\n}\n\n.section--form {\n    background-image: url(\"data:image/svg+xml,%3Csvg width='186' height='772' viewBox='0 0 186 772' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.2607 226.068C-18.0868 350.987 -18.0868 553.393 54.2607 678.311C90.4422 740.784 137.848 772.014 185.251 772H185.948V0L185.251 0C185.251 0 85.9281 171.496 54.2607 226.068Z' fill='%23F8BB18'/%3E%3C/svg%3E\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: top right;\n}\n\n@media (max-width: 769px) {\n    .section--form {\n        background-image: none;\n    }\n}\n\n.section--blue {\n    background-color: #3181F7;\n    color: #FFF;\n}\n\n.section--blue a {\n    color: #FFF;\n}\n\n.section--blue a:hover {\n    color: #000;\n}\n\n.section--blue > h1 span, .section--blue > h2 span {\n    color: #000;\n}\n\n.section--lightblue {\n    background-color: #DBECFE;\n}\n\n.rowForm {\n    margin-bottom: 1.5rem;\n    display: flex;\n    flex-direction: column;\n}\n\n.rowButton {\n    display: flex;\n    justify-content: center;\n    margin: 0.5rem 0;\n}\n\n.label {\n    color: #3181F7;\n    font-weight: 500;\n    font-size: 0.75rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 100%;\n    padding: 0 0.75rem;\n    margin-bottom: -1.5rem;\n    z-index: 5;\n}\n\n.input {\n    outline: none;\n    font-size: 0.85rem;\n    border: none;\n    background-color: #FFF;\n    padding: 2rem 0.75rem 0.5rem;\n}\n\n.input:focus {\n    outline: 2px solid #333;\n}\n\n.input.error {\n    outline: 2px solid #C00;\n}\n\n.label:has(+ .error) {\n    color: #C00;\n}\n\n\n.contentCard {\n    text-align: left;\n}\n\n.buttonExp {\n    margin: 3rem 0;\n}\n\n.buttonExp .btn--expand {\n    margin: 0;\n}\n\n@media (max-width: 769px) {\n    .buttonExp {\n        margin: 2rem 0;\n    }\n}\n\n.separador {\n    border-top: 1px solid #999;\n    width: 100%;\n    margin: 2rem 0;\n    max-width: 75rem;\n}\n\n@media (max-width: 769px) {\n    .separador {\n        margin: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
